import React, { memo, useEffect, useState } from "react";
import "./RVParkList.css";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import markerImg from "../../../../Assets/Images/orange-home.png";

const RVParkList = memo((props) => {
  const [rv_parklist, setRvDataList] = useState({});
  //get interactive map data
  useEffect(() => {
    if (props && props.data) {
      setRvDataList(props.data);
    }
  }, [props && props.data]);



  //price conversion
  const priceConversion = (tot) => {
    if (tot === null || tot === undefined)
      return null;

    if (tot !== "") {
      let checkDigit = tot.toString().split(".");
      let ret = "";
      let i = 0;
      if (tot.toString().indexOf(".") == -1) {
        tot = tot;
      } else {
        if (checkDigit == "00") {
          tot = checkDigit.trim();
        } else {
          if (checkDigit.length === 2) {
            ret += checkDigit[0] + ".";
            for (i = 0; i < checkDigit.length; i++) {
              if (i >= checkDigit[1].length) ret += "0";
              else ret += checkDigit[1][i];
            }
          } else if (checkDigit.length === 1) {
            ret += checkDigit[0] + ".";
            for (i = 0; i < checkDigit.length; i++) {
              ret += "0";
            }
          }
          ret = ret.toString();
          tot = ret;
        }
      }
    }
    return tot.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  return (
    <div>
      <div className="table-design">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Profile Name</TableCell>
              <TableCell>Proximity (miles)</TableCell>
              <TableCell>Facility Type</TableCell>
              <TableCell>No. of Spots</TableCell>
              <TableCell>Seasonality</TableCell>
              <TableCell>Google Rating</TableCell>
              <TableCell>Online Booking</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rv_parklist && rv_parklist.length > 0 ? (
              rv_parklist.map((data) => (
                <TableRow>
                  <TableCell>
                  {data.profilename ? data.profilename : "-"}{" "}
                  {data.ishome ?
                          <img
                            src={markerImg}
                            alt="Market Center"
                            height={15}
                            style={{marginRight:`2px`}}
                          ></img>
                          : ''}
                    <br />
                    <span>
                      {data.streetaddress1 ? data.streetaddress1 + ", " : ""}
                      {data.city ? data.city + ", " : ""}
                      {data.statecode ? data.statecode : ""}
                    </span>
                  </TableCell>
                  <TableCell> 
                    {data.proximity && data.proximity !== undefined ? priceConversion(data.proximity) === "0.00" ? '-' : priceConversion(data.proximity)  : "-"}
                  </TableCell>
                  <TableCell>
                    {data.facilitytypes ? data.facilitytypes : "-"}
                  </TableCell>
                  <TableCell>
                    {data.noofsites
                      ? data.noofsites
                      : "-"}
                  </TableCell>
                  <TableCell>
                    {data.seasonalityname ? data.seasonalityname : "-"}
                  </TableCell>
                  <TableCell>
                    {data.rating ? data.rating : "-"}
                  </TableCell>
                  <TableCell>
                        {data.onlinebookingstatus ? data.onlinebookingstatus : "-"}
                      </TableCell>
                  <TableCell>
                    {data.website ? (
                      <a href={"http://" + data.website} target="new">
                        Go to website
                      </a>
                    ) : (
                      ""
                    )}
                    </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell
                  style={{ textAlign: "center" }}
                  colSpan="5"
                  className="store-no-data"
                >
                  No records found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
});

export default RVParkList;
